import { z } from 'zod';

import { components } from '~/shared/api/schema/generated';

export type ProductInfoType = components['schemas']['ProductInfo'];
export type ProductPricesType = components['schemas']['ProductPrices'];
export type ProductType = components['schemas']['Product'];
export type BrandType = components['schemas']['Brand'];
export type CatalogItemType = components['schemas']['CatalogItem'];
export type CatalogResponseType = components['schemas']['CatalogResponse'];

export const BrandSchema = z
  .object({
    title: z.string().optional().catch(undefined),
    slug: z.string().optional().catch(undefined),
  })
  .passthrough()
  .catch({
    title: undefined,
    slug: undefined,
  });

export const ProductSchema = z
  .object({
    id: z.string().catch(''),
    name: z.string().catch(''),
    info: z.any().optional().catch(null),
    prices: z.any().catch({}),
  })
  .passthrough()
  .catch({
    id: '',
    name: '',
    info: null,
    prices: {},
  });
